// extracted by mini-css-extract-plugin
module.exports = {"navIcon":"Uk2Y5","rc-tabs-bar":"n2rTQ","rc-tabs-tab":"+rqHc","rc-tabs-tab-active":"IFT0b","terms":"Npqe6","orderHistory-navigation":"Jvr3W"};